import type { Account } from '@/api/generated/model';

export const TRADING_ACCOUNT_TYPES = ['investment', 'retirement', 'crypto'] as const;

export type TradingAccountType = (typeof TRADING_ACCOUNT_TYPES)[number];

export function accountSupportsHoldings(account: Account): boolean {
  const hasInvestingCapability =
    account.capabilities?.includes('trading') || account.capabilities?.includes('investing');
  return (
    hasInvestingCapability && TRADING_ACCOUNT_TYPES.includes(account.type as TradingAccountType)
  );
}
